import { Box } from '@chakra-ui/react'

import { Tooltip } from '../Tooltip'

interface IShortTextProps {
  text: string
  beforeChars?: number
  afterChars?: number
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'auto'
}

/**
 * Component that truncates long text showing beginning + end with tooltip.
 * Example: "https://example.com/very/long/path" -> "https://exam...long/path"
 *
 * @param text - The full text to display/truncate
 * @param beforeChars - Number of characters to show before truncation (default: 15)
 * @param afterChars - Number of characters to show after truncation (default: 15)
 * @param placement - Posição do tooltip. Sem ela vale o `top` do tema.
 */
export default function ShortText({ text, beforeChars = 15, afterChars = 15, placement }: IShortTextProps) {
  const truncationThreshold = beforeChars + afterChars
  const isTruncated = text.length > truncationThreshold
  const afterPart = afterChars > 0 ? text.slice(-afterChars) : ''

  const displayText = isTruncated ? `${text.slice(0, beforeChars)}...${afterPart}` : text

  return (
    <Tooltip label={text} placement={placement}>
      <Box as="span" cursor="help" title={text}>
        {displayText}
      </Box>
    </Tooltip>
  )
}
